export const getExtension = (filename) => {
  const re = /(?:\.([^.]+))?$/;
  return re.exec(filename)[1];
};
